import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const imgFn = /* @__PURE__ */ createRecipe('img', {}, [])

const imgVariantMap = {
  "fit": [
    "contain",
    "cover",
    "fill",
    "none",
    "scaleDown"
  ]
}

const imgVariantKeys = Object.keys(imgVariantMap)

export const img = /* @__PURE__ */ Object.assign(memo(imgFn.recipeFn), {
  __recipe__: true,
  __name__: 'img',
  __getCompoundVariantCss__: imgFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: imgVariantKeys,
  variantMap: imgVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, imgVariantKeys)
  },
  getVariantProps: imgFn.getVariantProps,
})